const SgiSpinEO = () => ({
    ctlH: '100%',
    ctlW: '100%',
    style: { minHeight: '200px' },
    desId: "EP_EO_UI_4006",
    loading: false,//初始加载中
})

export { SgiSpinEO };
export default SgiSpinEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiSpinEO.js